import React, { PropsWithChildren } from 'react';

import { Divider, Flex, Text } from '@opendoor/bricks/core';

interface ListingInfoProps {
  displayState: string;
  listingPrice?: number;
  soldPrice?: number;
  grossCommission?: number;
}

export const ListingInfo: React.FC<ListingInfoProps & PropsWithChildren> = ({
  displayState,
  listingPrice,
  soldPrice,
  grossCommission,
  children,
}) => {
  return (
    <Flex
      flexDirection="column"
      fontSize="s2"
      my={3}
      backgroundColor="neutrals20"
      borderRadius="semiRounded"
      p={3}
    >
      <Text fontWeight="semibold">Listing details</Text>
      <Text>
        Listing state: <br />
        {displayState}
      </Text>
      <Text>Listing price: {listingPrice ? listingPrice : 'Not yet set'} </Text>
      <Text>Sold price: {soldPrice ? soldPrice : 'Not yet set'} </Text>
      <Text>Gross commission: {grossCommission ? grossCommission : 'Not yet set'} </Text>

      <Divider my={3} />
      {children}
    </Flex>
  );
};
